// https://www.dbos.dev/customer-stories

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';
import { InViewSection, SlideIn } from '@components/interactions';

export function CustomerStoriesPage() {
  return (
    <SiteLayout banner={true} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <section className="section_hero">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large padding-top">
              <div className="product_component">
                <div className="max-width-large">
                  <div className="text-align-center">
                    <div className="margin-bottom margin-xsmall">
                      <div className="tagline-container_glow">
                        <div className="div-block-76">
                          <h1 className="text-size-small tagline-container is-glow is-ai">Customer Stories</h1>
                        </div>
                      </div>
                    </div>
                    <div className="margin-bottom margin-small">
                      <h2 className="heading-style-h1">
                        Brands building
                        <br />
                        <span>durably</span>
                        {' with DBOS'}
                      </h2>
                    </div>
                    <div className="margin-bottom margin-small">
                      <div className="max-width-medium">
                        <p className="text-body-active">
                          {
                            'Hundreds of customers use DBOS durable execution & workflow orchestration to build quality software faster.'
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="section_logo-cta">
                  <div className="div-block-41" data-ix="logo-marquee-80s">
                    <div className="collection-list-wrapper-3 w-dyn-list">
                      <div role="list" className="collection-list-7 w-dyn-items">
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571ef-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/69e64d266dcfe6a36e0767c7_walmart-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571ef-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/684a48c338268a5fc2bac97a_BMS-Logo.svg"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571ef-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/6a19b23a8e89f3b1180fe648_SeatGeek-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571ef-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/6a0dc63055842404afb10bfd_Notion-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571ef-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/69d4b4518528e6ebe275300a_Roche.svg"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571ef-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/6a26576fff679ec1b66fd004_Avnet-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571ef-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/69b0d4f7613c2dba1c87abdb_Orderful-logo2.svg"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571ef-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/692f972f7e0e5c80fdd2c6a2_Luma-AI-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="collection-list-wrapper-3 w-dyn-list">
                      <div role="list" className="collection-list-7 w-dyn-items">
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571f6-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/69e64d266dcfe6a36e0767c7_walmart-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571f6-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/684a48c338268a5fc2bac97a_BMS-Logo.svg"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571f6-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/6a0dc63055842404afb10bfd_Notion-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571f6-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/6a19b23a8e89f3b1180fe648_SeatGeek-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571f6-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/69d4b4518528e6ebe275300a_Roche.svg"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571f6-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/6a26576fff679ec1b66fd004_Avnet-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571f6-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/69b0d4f7613c2dba1c87abdb_Orderful-logo2.svg"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571f6-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/692f972f7e0e5c80fdd2c6a2_Luma-AI-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="collection-list-wrapper-3 w-dyn-list">
                      <div role="list" className="collection-list-7 w-dyn-items">
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571fd-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/69b0d4f7613c2dba1c87abdb_Orderful-logo2.svg"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571fd-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/692f98c5782404bdf8e4410e_Pelican-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571fd-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/6a265740d597c8e6798da957_MUFG-logo2.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571fd-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/6a19b23a8e89f3b1180fe648_SeatGeek-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571fd-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/684a48c338268a5fc2bac97a_BMS-Logo.svg"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571fd-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/69d4b4518528e6ebe275300a_Roche.svg"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571fd-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/69e64d266dcfe6a36e0767c7_walmart-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571fd-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/6a0dc63055842404afb10bfd_Notion-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                        <div
                          id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd5571fd-b76868b6"
                          role="listitem"
                          className="collection-item-5 w-dyn-item"
                        >
                          <img
                            src="/assets/cms/6a26576fff679ec1b66fd004_Avnet-logo.png"
                            loading="lazy"
                            alt=""
                            className="image-17"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="div-block-44" data-ix="logo-marquee-60s">
                    <div className="div-block-41" data-ix="logo-marquee-80s">
                      <div className="collection-list-wrapper-3 w-dyn-list">
                        <div role="list" className="collection-list-7 w-dyn-items">
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8cb8aad74b0bd71dcbdf7_Workstuff-AI-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8cae4c8e36a13c00a5aad_Veritus-Agent-logo-1.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8ca1dec37f05df1b56358_Andel-Org-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c9a7305b15244a0ab262_dltHub-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c74f1ceb827f1877fdb1_Rematiq-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c77c60d0fc55d5712490_Nocd-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c838c08215604ff2c930_Nory-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c85f663da3860bd38036_LatchBio-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a26576fff679ec1b66fd004_Avnet-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a265740d597c8e6798da957_MUFG-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a19b23a8e89f3b1180fe648_SeatGeek-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a0df5793d746036f7cc241e_FlowGen-Labs-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a0dc63055842404afb10bfd_Notion-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="https://cdn.prod.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg"
                              loading="lazy"
                              alt=""
                              className="image-17 w-dyn-bind-empty"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="https://cdn.prod.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg"
                              loading="lazy"
                              alt=""
                              className="image-17 w-dyn-bind-empty"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69e64d266dcfe6a36e0767c7_walmart-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4b4518528e6ebe275300a_Roche.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc29ab9cac019dffb08f_ocula-technologies.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69b0d4f7613c2dba1c87abdb_Orderful-logo2.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69fca0f55bf9e8e1d151777b_Stuut-logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/692f98c5782404bdf8e4410e_Pelican-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/692f972f7e0e5c80fdd2c6a2_Luma-AI-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc21bab5c6ce0d75b2f4_goblins-app.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc64e48ce50044f90307_dosu.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6894211b21c704cd0641fec3_cStructure-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bd94ec2b1771c2ef8782_supabase.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a5f4253d94a6e319eb866_OpenPit-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a5c46db1d55c3c680ba55_Coyax-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc5a8f5d183a87c4b1c9_soria-analytics.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a4f3bddaaefeafde9a924_Default-Com-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="https://cdn.prod.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg"
                              loading="lazy"
                              alt=""
                              className="image-17 w-dyn-bind-empty"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc7a5d6f311045a75214_Yutori.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a4794b2e8d8efc78902fa_Trustle-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a48c338268a5fc2bac97a_BMS-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a448eddd3bf98456f5530b_playfix-Logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a4478dc32b9c82f6d90472_Pin-Out-Logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a44180c41e3f2060b782a6_Strobe-Alert-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a440a450b5c5639417bb2a_Digital-Underground-Technology-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc3342235ab33aec6c4f_Ravenholt.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a430264b81088f346238d4_Pearstop-logo-white.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/673d27061af0558b20254b3e_zeep-chat.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67242fbc49dd3e04041ba3db_Bighire.io.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557206-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69afa10081de9a634f0bb69f_Zaelab-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="collection-list-wrapper-3 w-dyn-list">
                        <div role="list" className="collection-list-7 w-dyn-items">
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8cb8aad74b0bd71dcbdf7_Workstuff-AI-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8cae4c8e36a13c00a5aad_Veritus-Agent-logo-1.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8ca1dec37f05df1b56358_Andel-Org-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c9a7305b15244a0ab262_dltHub-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c74f1ceb827f1877fdb1_Rematiq-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c77c60d0fc55d5712490_Nocd-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c838c08215604ff2c930_Nory-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c85f663da3860bd38036_LatchBio-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a26576fff679ec1b66fd004_Avnet-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a265740d597c8e6798da957_MUFG-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a19b23a8e89f3b1180fe648_SeatGeek-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a0df5793d746036f7cc241e_FlowGen-Labs-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a0dc63055842404afb10bfd_Notion-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="https://cdn.prod.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg"
                              loading="lazy"
                              alt=""
                              className="image-17 w-dyn-bind-empty"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="https://cdn.prod.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg"
                              loading="lazy"
                              alt=""
                              className="image-17 w-dyn-bind-empty"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69e64d266dcfe6a36e0767c7_walmart-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4b4518528e6ebe275300a_Roche.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc29ab9cac019dffb08f_ocula-technologies.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69b0d4f7613c2dba1c87abdb_Orderful-logo2.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69fca0f55bf9e8e1d151777b_Stuut-logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/692f98c5782404bdf8e4410e_Pelican-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/692f972f7e0e5c80fdd2c6a2_Luma-AI-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc21bab5c6ce0d75b2f4_goblins-app.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc64e48ce50044f90307_dosu.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6894211b21c704cd0641fec3_cStructure-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bd94ec2b1771c2ef8782_supabase.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a5f4253d94a6e319eb866_OpenPit-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a5c46db1d55c3c680ba55_Coyax-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc5a8f5d183a87c4b1c9_soria-analytics.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a4f3bddaaefeafde9a924_Default-Com-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="https://cdn.prod.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg"
                              loading="lazy"
                              alt=""
                              className="image-17 w-dyn-bind-empty"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc7a5d6f311045a75214_Yutori.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a4794b2e8d8efc78902fa_Trustle-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a48c338268a5fc2bac97a_BMS-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a448eddd3bf98456f5530b_playfix-Logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a4478dc32b9c82f6d90472_Pin-Out-Logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a44180c41e3f2060b782a6_Strobe-Alert-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a440a450b5c5639417bb2a_Digital-Underground-Technology-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc3342235ab33aec6c4f_Ravenholt.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a430264b81088f346238d4_Pearstop-logo-white.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/673d27061af0558b20254b3e_zeep-chat.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67242fbc49dd3e04041ba3db_Bighire.io.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd55720d-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69afa10081de9a634f0bb69f_Zaelab-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="collection-list-wrapper-3 w-dyn-list">
                        <div role="list" className="collection-list-7 w-dyn-items">
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8cb8aad74b0bd71dcbdf7_Workstuff-AI-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8cae4c8e36a13c00a5aad_Veritus-Agent-logo-1.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8ca1dec37f05df1b56358_Andel-Org-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c9a7305b15244a0ab262_dltHub-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c74f1ceb827f1877fdb1_Rematiq-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c77c60d0fc55d5712490_Nocd-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c838c08215604ff2c930_Nory-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6aa8c85f663da3860bd38036_LatchBio-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a26576fff679ec1b66fd004_Avnet-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a265740d597c8e6798da957_MUFG-logo2.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a19b23a8e89f3b1180fe648_SeatGeek-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a0df5793d746036f7cc241e_FlowGen-Labs-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6a0dc63055842404afb10bfd_Notion-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="https://cdn.prod.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg"
                              loading="lazy"
                              alt=""
                              className="image-17 w-dyn-bind-empty"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="https://cdn.prod.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg"
                              loading="lazy"
                              alt=""
                              className="image-17 w-dyn-bind-empty"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69e64d266dcfe6a36e0767c7_walmart-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4b4518528e6ebe275300a_Roche.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc29ab9cac019dffb08f_ocula-technologies.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69b0d4f7613c2dba1c87abdb_Orderful-logo2.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69fca0f55bf9e8e1d151777b_Stuut-logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/692f98c5782404bdf8e4410e_Pelican-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/692f972f7e0e5c80fdd2c6a2_Luma-AI-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc21bab5c6ce0d75b2f4_goblins-app.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc64e48ce50044f90307_dosu.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/6894211b21c704cd0641fec3_cStructure-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bd94ec2b1771c2ef8782_supabase.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a5f4253d94a6e319eb866_OpenPit-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a5c46db1d55c3c680ba55_Coyax-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc5a8f5d183a87c4b1c9_soria-analytics.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a4f3bddaaefeafde9a924_Default-Com-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="https://cdn.prod.website-files.com/plugins/Basic/assets/placeholder.60f9b1840c.svg"
                              loading="lazy"
                              alt=""
                              className="image-17 w-dyn-bind-empty"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc7a5d6f311045a75214_Yutori.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a4794b2e8d8efc78902fa_Trustle-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/684a48c338268a5fc2bac97a_BMS-Logo.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a448eddd3bf98456f5530b_playfix-Logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a4478dc32b9c82f6d90472_Pin-Out-Logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a44180c41e3f2060b782a6_Strobe-Alert-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a440a450b5c5639417bb2a_Digital-Underground-Technology-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69d4bc3342235ab33aec6c4f_Ravenholt.avif"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67a430264b81088f346238d4_Pearstop-logo-white.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/673d27061af0558b20254b3e_zeep-chat.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/67242fbc49dd3e04041ba3db_Bighire.io.svg"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                          <div
                            id="w-node-_668df061-ffb6-ddab-b1c9-ce9fcd557214-b76868b6"
                            role="listitem"
                            className="collection-item-5 w-dyn-item"
                          >
                            <img
                              src="/assets/cms/69afa10081de9a634f0bb69f_Zaelab-logo.png"
                              loading="lazy"
                              alt=""
                              className="image-17"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section-wrapper">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large">
              <div fs-list-filteringclass="is-list-filtering" className="partnerships_featured-list-wrapper w-dyn-list">
                <div role="list" className="partnerships_featured-list w-dyn-items">
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fbc788584b9ebac26ce46a_Walmart.avif"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">Retail</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Walmart</h3>
                      </div>
                      <p className="text-body-active">
                        Walmart integrated DBOS into its internal agentic AI framework to ensure agents are reliable and
                        observable by default.
                      </p>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/6a0dc56b65ad514e1c80faa4_Notion-Icon-DBOS.png"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">Software</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Notion</h3>
                      </div>
                      <p className="text-body-active">
                        Migrated the Notion Mail async job system off of BullMQ and onto DBOS. Executing 190M durable
                        workflows per day, peaking at 5K per second. The migration reduced daily AWS costs by $11K per
                        day
                      </p>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fd732f2716fe861716e592_Roche-Icon-DBOS.png"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">Healthcare</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Roche</h3>
                      </div>
                      <p className="text-body-active">
                        DBOS chosen to make lab automation workflows reliable and durable, running on Kubernetes in
                        diverse computing environments, including multi-region.
                      </p>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fbc7ca8695c6f02b451c64_Yutori.avif"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">AI Software</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Yutori</h3>
                      </div>
                      <p className="text-body-active">
                        Yutori.ai has launched an autonomous AI system hosted on DBOS due to its proven ability to
                        ensure durable AI workflow execution at scale.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/yutori-large-scale-durable-agentic-ai"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fbc7d144e637bae2efe6cb_BMS.avif"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">Life Sciences</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">BMS</h3>
                      </div>
                      <p className="text-body-active">
                        Reliable and observable genomic sequencing data pipelines. Parallel processing enabled by DBOS
                        durable queueing improved pipeline performance 40x, at a fraction of the cost.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/bms"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fd709f4f739c84981feeab_Luma-AI-Icon-DBOS.png"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">AI</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Luma AI</h3>
                      </div>
                      <p className="text-body-active">
                        AI video generation. Leveraging DBOS workflows and queues to reliably execute AI video
                        generation and reasoning workflows in a distributed environment.
                      </p>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fd6ec70fa83aed3726042b_Ordeful-Icon-DBOS.png"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">Enterprise Integration Software</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Orderful</h3>
                      </div>
                      <p className="text-body-active">
                        Orderful is modernizing EDI for retail, logistics, and supply chain. Orderful replaced RabbitMQ
                        with DBOS to run 2 million transaction processing workflows a day.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/orderful-resilient-edi-at-scale"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fd79a91bc4b49823477e89_Run-Riviera-Icon-DBOS.png"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">AI - Healthcare</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Riviera</h3>
                      </div>
                      <p className="text-body-active">
                        DBOS ensures backend AI CRM workflows execute reliably and with full observability amid software
                        updates, system failures, and unpredictable humans in the loop.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/riviera-ai-powered-crm-elective-healthcare"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fd76b2275a8625e03fc6b6_Automata-Icon-DBOS.png"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">AI Lab Automation</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Automata</h3>
                      </div>
                      <p className="text-body-active">
                        AI lab automation workflows in an air-gapped environment. Selected DBOS for architectural
                        simplicity and ease of deployment into lab environments disconnected from the web.
                      </p>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fca03dc4a30096d9657cf6_Stuut-Icon-DBOS.png"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">AI Software</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Stuut Technologies</h3>
                      </div>
                      <p className="text-body-active">
                        Agentic AI for accounts receivable. Selected DBOS to orchestrate durable payment workflows
                        without sensitive data leaving the premises, and without critical-path dependency on external
                        orchestration services.
                      </p>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fbc7933fad50fcbc75ff75_Goblins.avif"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">AI, EdTech</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Goblins</h3>
                      </div>
                      <p className="text-body-active">
                        Goblins applies agentic AI for personalized 1:1 math tutoring for students. Goblins switched
                        from Inngest to DBOS to simplify development and improve workflow performance.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/goblins-durable-agentic-ai"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fbc79aa7aa5bce3fb671f2_Dosu.avif"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">Software, AI</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Dosu</h3>
                      </div>
                      <p className="text-body-active">
                        An agentic AI system that transforms codebases into living knowledge bases for software teams.
                        DBOS durable execution and queuing makes the system reliable and observable for the 50,000
                        software projects that use Dosu.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/dosu"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fbc7c2a7a32f5a876ea82b_Ontologize.avif"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">Software</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Ontologize</h3>
                      </div>
                      <p className="text-body-active">
                        DBOS workflows deploy thousands of isolated Palantir software stacks per day to Palantir
                        trainees.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/ontologize"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/6a0de1aaed314508a8b6d934_FlowGen_Labs-Icon-DBOS.png"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">AI - Agentic ERP Ops</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">FlowGen Labs</h3>
                      </div>
                      <p className="text-body-active">
                        FlowGen Labs selected DBOS over Temporal to make long-lived workflows durable and observable
                        within the rigid security constraints of customer environments, including air-gapped
                        deployments.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/flowgen-labs"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fbc7ade434619a6eb658e3_Soria.avif"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">AI Healthcare Software</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Soria</h3>
                      </div>
                      <p className="text-body-active">
                        Soria AI turns messy, public datasets into a single, trusted intelligence layer for investors
                        and operators. DBOS durable execution and queuing make these pipelines reliable, observable, and
                        easy to scale.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/soria-ai-healthcare-data-processing"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fbc7a0fb7ce15dfb5a4b99_cStructure.avif"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">Life Sciences, AI</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">cStructure</h3>
                      </div>
                      <p className="text-body-active">
                        Using DBOS to minimize coding complexity and time to market for cStructure causal inference
                        system. DBOS durable execution architecture made it easy to ensure life science data privacy.
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/ai-powered-causal-reasoning"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fbc7a6a99bce2b0d87e3d7_Supabase.avif"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">Software</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Supabase</h3>
                      </div>
                      <p className="text-body-active">
                        {
                          '"I love the design of DBOS. If you\'re a gamer, it\'s like having a “save point” in your programs. If a function fails, a new function starts, picking up at the last checkpoint." - Paul Copplestone, CEO'
                        }
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/supabase"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div role="listitem" className="partnerships_featured-item w-dyn-item">
                    <div className="partnerships_header is-customer-stories">
                      <div className="partner_logo-wrapper">
                        <img
                          src="/assets/cms/69fbc7e241ef76878afc0f27_Zaelab.avif"
                          loading="lazy"
                          alt=""
                          className="partner_logo"
                        />
                      </div>
                      <p className="tagline-container text-size-small">eCommerce</p>
                    </div>
                    <div className="partnerships_content">
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h5">Zaelab</h3>
                      </div>
                      <p className="text-body-active">
                        “What took us 2 months to build using a labyrinth of AWS resources took just 2 days on DBOS
                        Cloud.” - Thomas McNally, VP Technology
                      </p>
                    </div>
                    <div
                      data-wf--button--variant="tertiary-large"
                      className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                    >
                      <a
                        href="/case-studies/tmg-io"
                        className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                      >
                        <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                          Read case study
                        </div>
                        <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
        <div className="layout_glow-container">
          <img
            src="/assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow.avif"
            loading="lazy"
            sizes="(max-width: 3999px) 100vw, 3999px"
            srcSet="/assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-500.avif 500w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-800.avif 800w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-1080.avif 1080w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-1600.avif 1600w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-2000.avif 2000w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-2600.avif 2600w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-3200.avif 3200w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow.avif 3999w"
            alt=""
            className="layout_code-glow"
          />
        </div>
      </section>
      <section className="section_testimonials">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-medium is-testimonial">
              <div className="margin-bottom margin-medium">
                <div className="layout-2col_component is-testimonials">
                  <div className="margin-bottom">
                    <div className="text-align-center">
                      <div className="margin-bottom margin-xsmall">
                        <div className="tagline-container_glow">
                          <h2 className="text-size-small tagline-container is-glow">Testimonials</h2>
                        </div>
                      </div>
                      <div className="max-width-medium">
                        <div className="margin-bottom margin-small is-partner">
                          <h3 className="heading-style-h2">{'Loved by AI, Cloud &\u00a0Data teams'}</h3>
                        </div>
                        <div className="margin-bottom margin-small">
                          <div className="max-width-small">
                            <p className="text-body-active">
                              Helping more devs, AI engineers, and SREs orchestrate fault-tolerant workflows.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="testimonial_container">
                <InViewSection className="testimonial_component" as="div" data-ix="testimonial-carousel">
                  <div className="testimonial_loop-wrapper w-dyn-list">
                    <div role="list" className="testimonial_loop-list w-dyn-items">
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc7a5d6f311045a75214_Yutori.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"We\'ve been impressed by how lightweight and flexible DBOS is, the speed at which their team ships, and the level of support offered. We, at Yutori, are happy customers and excited to scale with DBOS."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3b20af8f7964cc68f88_abhishek-das-yutori.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Abhishek Das</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/yutori-large-scale-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc5a8f5d183a87c4b1c9_soria-analytics.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS makes it dead simple for our engineering team to build reliable, low-latency,
                                AI-powered user experiences."
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b345fda9a2ca1fd247a4_cameron-spiller-soria.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Cameron Spiller</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/soria-ai-healthcare-data-processing"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bd94ec2b1771c2ef8782_supabase.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"I love the design of DBOS. If you\'re a gamer, it\'s like having a “save point” in your programs. If a function fails, a new function can start, picking up at the last checkpoint."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b39f9f54ce90e624acab_paul-copplestone-supabase.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Paul Copplestone</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-Founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/supabase"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc64e48ce50044f90307_dosu.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS is really simple to manage. It gives us durable orchestration and observability
                                without a lot of coding and without having to run additional infrastructure.”
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3986ca57d7a19ca98d1_devin-stein-dosu.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Devin Stein</div>
                              <p className="text-size-small text-weight-regular">CEO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/dosu"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '\u200d“We looked at Google Workflows, Temporal, Airflow and Celery but DBOS was the one framework that solved many pieces of the puzzle while giving us implementation flexibility.”'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b378ad90b001f593f517_shelby-vanhooser-ontologize.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Shelby Vanhooser</div>
                              <p className="text-size-small text-weight-regular">Engineer</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/ontologize"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc21bab5c6ce0d75b2f4_goblins-app.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>{'"DBOS\u00a0makes it impossible to screw up."'}</p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b38d7a410a07a9818e1a_alp-karavil-goblins.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Alp Karavil</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/goblins-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial_loop-wrapper w-dyn-list">
                    <div role="list" className="testimonial_loop-list w-dyn-items">
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc7a5d6f311045a75214_Yutori.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"We\'ve been impressed by how lightweight and flexible DBOS is, the speed at which their team ships, and the level of support offered. We, at Yutori, are happy customers and excited to scale with DBOS."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3b20af8f7964cc68f88_abhishek-das-yutori.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Abhishek Das</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/yutori-large-scale-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc5a8f5d183a87c4b1c9_soria-analytics.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS makes it dead simple for our engineering team to build reliable, low-latency,
                                AI-powered user experiences."
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b345fda9a2ca1fd247a4_cameron-spiller-soria.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Cameron Spiller</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/soria-ai-healthcare-data-processing"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bd94ec2b1771c2ef8782_supabase.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"I love the design of DBOS. If you\'re a gamer, it\'s like having a “save point” in your programs. If a function fails, a new function can start, picking up at the last checkpoint."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b39f9f54ce90e624acab_paul-copplestone-supabase.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Paul Copplestone</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-Founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/supabase"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc64e48ce50044f90307_dosu.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS is really simple to manage. It gives us durable orchestration and observability
                                without a lot of coding and without having to run additional infrastructure.”
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3986ca57d7a19ca98d1_devin-stein-dosu.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Devin Stein</div>
                              <p className="text-size-small text-weight-regular">CEO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/dosu"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '\u200d“We looked at Google Workflows, Temporal, Airflow and Celery but DBOS was the one framework that solved many pieces of the puzzle while giving us implementation flexibility.”'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b378ad90b001f593f517_shelby-vanhooser-ontologize.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Shelby Vanhooser</div>
                              <p className="text-size-small text-weight-regular">Engineer</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/ontologize"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc21bab5c6ce0d75b2f4_goblins-app.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>{'"DBOS\u00a0makes it impossible to screw up."'}</p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b38d7a410a07a9818e1a_alp-karavil-goblins.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Alp Karavil</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/goblins-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial_loop-wrapper w-dyn-list">
                    <div role="list" className="testimonial_loop-list w-dyn-items">
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc7a5d6f311045a75214_Yutori.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"We\'ve been impressed by how lightweight and flexible DBOS is, the speed at which their team ships, and the level of support offered. We, at Yutori, are happy customers and excited to scale with DBOS."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3b20af8f7964cc68f88_abhishek-das-yutori.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Abhishek Das</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/yutori-large-scale-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc5a8f5d183a87c4b1c9_soria-analytics.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS makes it dead simple for our engineering team to build reliable, low-latency,
                                AI-powered user experiences."
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b345fda9a2ca1fd247a4_cameron-spiller-soria.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Cameron Spiller</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/soria-ai-healthcare-data-processing"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bd94ec2b1771c2ef8782_supabase.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"I love the design of DBOS. If you\'re a gamer, it\'s like having a “save point” in your programs. If a function fails, a new function can start, picking up at the last checkpoint."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b39f9f54ce90e624acab_paul-copplestone-supabase.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Paul Copplestone</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-Founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/supabase"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc64e48ce50044f90307_dosu.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS is really simple to manage. It gives us durable orchestration and observability
                                without a lot of coding and without having to run additional infrastructure.”
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3986ca57d7a19ca98d1_devin-stein-dosu.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Devin Stein</div>
                              <p className="text-size-small text-weight-regular">CEO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/dosu"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '\u200d“We looked at Google Workflows, Temporal, Airflow and Celery but DBOS was the one framework that solved many pieces of the puzzle while giving us implementation flexibility.”'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b378ad90b001f593f517_shelby-vanhooser-ontologize.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Shelby Vanhooser</div>
                              <p className="text-size-small text-weight-regular">Engineer</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/ontologize"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc21bab5c6ce0d75b2f4_goblins-app.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>{'"DBOS\u00a0makes it impossible to screw up."'}</p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b38d7a410a07a9818e1a_alp-karavil-goblins.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Alp Karavil</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/goblins-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </InViewSection>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
    </SiteLayout>
  );
}
